import axios from "axios"
import config from "~/config";
import httpCode from "~/constants/httpCode";
import {
  AccessDeniedException,
  NotFoundException,
  BadRequestException,
  ValidationException,
  AuthException,
  ServerErrorException,
  NetworkErrorException,
  UnprocessableEntityException
} from "./errorHelper";
import { getAccessToken, getVerificationToken } from "./tokenHelper";

const axiosApi = axios.create({
  baseURL: config.API_BE_URL as string,
});

axiosApi.interceptors.request.use(config => {
  const authToken = getAccessToken();
  const verificationToken = getVerificationToken();
  config.headers.Authorization = `Bearer ${authToken}.${verificationToken}`;
  return config;
});

axiosApi.interceptors.response.use(
  response => response,
  error => {
    if (!!error.response) {
      console.log(error.response.status)
      switch (error.response.status) {
        case httpCode.unauthorized:
          error = new AuthException(undefined, error.response.data.code);
          break;
        case httpCode.forbidden:
          error = new AccessDeniedException(undefined, error.response.data.code);
          break;
        case httpCode.notFound:
          error = new NotFoundException(undefined, error.response.data.code);
          break;
        case httpCode.badRequest:
          if (error.response.data.fields) {
            error = new ValidationException(undefined, error.response.data.fields);
          } else {
            error = new BadRequestException(undefined, error.response.data.code);
          }
          break;
        case httpCode.unprocessableEntity:
          error = new UnprocessableEntityException(error.response.data.message, error.response.data.code);
          break;
        case httpCode.internalServerError:
          error = new ServerErrorException(undefined, error.response.data.code);
          break;
      }
    } else if (!!error.request) {
      // we have a request but not a response
      // so this is most likely a network problem
      error = new NetworkErrorException();
    }
    return Promise.reject(error);
  }
);

export const get = <Type>(url: string, config = {}) => axiosApi
  .get<Type>(url, config)
  .then(response => response.data);

export const post = <Type>(url: string, data?: any, config = {}) => axiosApi
  .post<Type>(url, data, config)
  .then(response => response.data);

export const put = <Type>(url: string, data?: any, config = {}) => axiosApi
  .put<Type>(url, data, config)
  .then(response => response.data);

export const del = <Type>(url: string, config = {}) => axiosApi
  .delete<Type>(url, config)
  .then(response => response.data);